import { jsx } from "react/jsx-runtime";
import { Input } from "antd";
import { forwardRef } from "react";
import { overrideCountProp, overrideShowCountProp } from "./utils.js";
import { rootClass } from "./constant.js";
import classnames from "classnames";
const TextArea = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { rows = 1, showCount: inputShowCount, count: inputCount, ...restProps } = props;
    const showCount = overrideShowCountProp(inputShowCount);
    const count = overrideCountProp(inputCount);
    return /*#__PURE__*/ jsx(Input.TextArea, {
        ...restProps,
        rows: rows,
        showCount: showCount,
        count: count,
        ref: ref,
        className: classnames(rootClass, restProps.className)
    });
});
export { TextArea };
